// extracted by mini-css-extract-plugin
module.exports = {"buttons":"ConfirmModal_buttons__3-d2o","alertIcon":"ConfirmModal_alertIcon__3VLi5"};